const workspaceArchiveFallbackIconUrl = new URL(
  "../assets/workspace-archive-fallback.png",
  import.meta.url
).href;

export default workspaceArchiveFallbackIconUrl;
